"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textMarshal = void 0;
const helper_1 = require("./helper");
function textMarshal({ input = "", template = "", disallowCharacters = [], isRepeat: { value, removeStart, removeEnd } = {
    value: false,
    removeStart: false,
    removeEnd: false,
}, }) {
    try {
        template = template.toLowerCase();
        if (value == true && input.length > (0, helper_1.letterCount)(template, "x")) {
            template = template.repeat(Math.ceil(input.length / (0, helper_1.letterCount)(template, "x")));
        }
        if (removeEnd && template[0] !== "x") {
            template = (0, helper_1.setCharAt)(template, 0, "");
        }
        if (removeStart && template[template.length - 1] !== "x") {
            template = (0, helper_1.setCharAt)(template, template.length - 1, "");
        }
        let templateclone = template;
        let j = 0;
        let plaintext = "";
        let countj = 0;
        while (j < template.length) {
            // code block to be
            if (countj > input.length - 1) {
                template = template.substring(0, j);
                templateclone = templateclone.substring(0, j);
                break;
            }
            if (template[j] == input[j]) {
                j++;
                countj++;
                continue;
            }
            if (disallowCharacters &&
                (0, helper_1.isCharExist)(input[countj], disallowCharacters)) {
                countj++;
                continue;
            }
            if (template[j] == "x") {
                template = (0, helper_1.setCharAt)(template, j, input[countj]);
                plaintext = plaintext + input[countj];
                countj++;
            }
            j++;
        }
        return {
            template: templateclone,
            plaintext: plaintext,
            marshaltext: template,
        };
    }
    catch {
        return {
            template: "",
            plaintext: "",
            marshaltext: "",
        };
    }
}
exports.textMarshal = textMarshal;
